<template>
  <v-container fluid>
    <delete-dialog
      :dialog="confirmDelete"
      v-on:confirm-delete="removeRole"
      v-on:cancel-dialog="
        () => {
          selectedRole = undefined;
          confirmDelete = false;
        }
      "
    >
    </delete-dialog>
    <v-data-table :headers="headers" :items="roles">
      <template v-slot:[`item.permissionCount`]="{ item }">
        <b>{{ item.permissionCount }}</b> {{ $t("roles.permissionCounts") }}
      </template>

      <template v-slot:[`item.isDefault`]="{ item }">
        <v-icon color="success" v-if="item.isDefault">mdi-check</v-icon>
        <v-icon color="error" v-else>mdi-close-octagon-outline</v-icon>
      </template>

      <template v-slot:[`item.isSuper`]="{ item }">
        <v-icon color="success" v-if="item.isSuper">mdi-check</v-icon>
        <v-icon color="error" v-else>mdi-close-octagon-outline</v-icon>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <v-btn
          v-if="!item.isDefault && permitted('Roles.Update')"
          router
          :to="`/roles/edit/${item.userRoleId}`"
          icon
        >
          <v-icon color="primary"> mdi-pencil </v-icon>
        </v-btn>

        <v-btn
          v-if="!item.isDefault && permitted('Roles.Delete')"
          icon
          @click="
            () => {
              selectedRole = item;
              confirmDelete = true;
            }
          "
        >
          <v-icon color="error"> mdi-delete </v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import roleRepository from "@/api/repositories/roleRepository";
import DeleteDialog from "../common/DeleteDialog.vue";

export default {
  name: "RoleList",

  components: { DeleteDialog },

  methods: {
    ...mapActions("roles", ["getRolesByCompany"]),

    async removeRole() {
      if (this.selectedRole === undefined || this.selectedRole.isDefault)
        return;

      await roleRepository.delete(this.selectedRole.userRoleId);
      await this.getRolesByCompany();
      this.selectedRole = undefined;
      this.confirmDelete = false;
    },
  },

  computed: {
    ...mapState("roles", ["roles"]),
  },

  data() {
    return {
      headers: [
        { text: this.$t("roles.fields.name"), value: "name" },
        {
          text: this.$t("roles.fields.permissionCount"),
          value: "permissionCount",
        },

        {
          text: this.$t("roles.fields.isDefault"),
          value: "isDefault",
        },

        {
          text: this.$t("roles.fields.isSuper"),
          value: "isSuper",
        },

        {
          text: "",
          value: "action",
        },
      ],
      confirmDelete: false,
      selectedRole: undefined,
    };
  },

  async created() {
    await this.getRolesByCompany();
  },
};
</script>
